import { useState } from 'react';
import useSubscriptionActions from './actions/subscription.hooks';

const useGetSBAccountTile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);

  const { getSubscriptionOverview } = useSubscriptionActions();

  const fetchData = ({ fromDate, endDate }) => {
    setIsLoading(true);
    getSubscriptionOverview({ fromDate, endDate })
      .then((response) => {
        setData(response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return {
    isLoading,
    data,
    fetchData
  }
}

export default useGetSBAccountTile;
